export default {
  apiUrl: "/api/wp-users",
  dataPath: "result.rows",
  paginationPath: "data",
  trackBy: "id",
  detailRowComponentName: "",
  customActionComponentName: "WpUserManagementCustomActionComponent",
  onEachSide: 1,
  preloadList: [],
  sortOrder: [
    {
      field: "id",
      sortField: "id",
      direction: "DESC"
    }
  ],
  paginationTemplate: {
    class: "",
    template: "총 {total}개 중의 {from} 부터 {to}"
  },
  fields: [
    {
      name: "__slot:actions",
      title: "수정 삭제",
      titleClass: "center aligned",
      dataClass: "center aligned"
    },
    {
      name: "id",
      title: '<i style="white-space: nowrap">아이디</i>',
      sortField: "id",
      titleClass: "text-center",
      dataClass: "text-right"
    },
    {
      name: "email",
      title: '<i style="white-space: nowrap">이메일</i>',
      titleClass: "text-center",
      dataClass: "text-right",
      callback: "emailField"
    },
    {
      name: "phone",
      title: '<p style="white-space: nowrap">연락처</p>',
      titleClass: "text-center",
      dataClass: "text-right",
      callback: "phoneField"
    },
    {
      name: "name",
      title: '<i style="white-space: nowrap">이름</i>',
      sortField: "name",
      titleClass: "text-center",
      dataClass: "text-right",
      callback: "nameField"
    },
    {
      name: "birth",
      title: '<i style="white-space: nowrap">생년월일</i>',
      sortField: "birth",
      titleClass: "text-center",
      dataClass: "text-right"
      // callback: "nameField"
    },
    {
      name: "facebook_id",
      title: '<i style="white-space: nowrap">페이스북</i>',
      sortField: "facebook_id",
      titleClass: "text-center",
      dataClass: "text-right"
      // callback: "socialField"
    },
    {
      name: "kakao_id",
      title: '<i style="white-space: nowrap">카카오</i>',
      sortField: "kakao_id",
      titleClass: "text-center",
      dataClass: "text-right"
      // callback: "socialField"
    },
    {
      name: "terms_noti_sms",
      title: '<i style="white-space: nowrap">SMS수신</i>',
      titleClass: "text-center",
      dataClass: "text-right",
      callback: "toggleField"
    },
    {
      name: "is_temp",
      title: '<p style="white-space: nowrap">임시계정</p>',
      titleClass: "text-center",
      dataClass: "text-right",
      callback: "toggleField"
    },
    {
      name: "is_deleted",
      title: '<i style="white-space: nowrap">삭제</i>',
      titleClass: "text-center",
      dataClass: "text-right",
      callback: "toggleField"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/spa/components/board/wp-user-management/Config.js